/* Muse Aria -- rotating best-seller name next to the header search icon (GM-style) */
(function () {
  var NAMES = [
    { label: "Mars 2.0", q: "Mars 2.0 Top Handle" },
    { label: "Sky Mini", q: "Sky Mini Bag" },
    { label: "Noa", q: "Noa Long Handle" },
    { label: "Zaria", q: "Zaria Top Handle" },
    { label: "Aria", q: "Aria Long Top Handle" }
  ];
  function initRotator() {
    var header = document.querySelector('.header');
    if (!header || header.querySelector('.ma-search-rotator')) return;
    var searchIcon = header.querySelector('.header__icon--search') ||
                     header.querySelector('a[href*="/search"]');
    if (!searchIcon) return;
    var anchorNode = searchIcon.closest('details-modal') ||
                     searchIcon.closest('details') || searchIcon;
    var container = anchorNode.parentNode;
    if (!container) return;

    var a = document.createElement('a');
    a.className = 'ma-search-rotator';
    a.href = '/search?q=' + encodeURIComponent(NAMES[0].q);
    a.setAttribute('aria-label', 'Search best sellers');
    var span = document.createElement('span');
    span.className = 'ma-search-rotator__text';
    span.textContent = NAMES[0].label;
    a.appendChild(span);
    container.insertBefore(a, anchorNode);

    // Open the search overlay (prefilled) instead of navigating to a search page.
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var toggle = document.querySelector('.header__search summary, .header__search .header__icon--search');
      if (toggle) { toggle.click(); }
      setTimeout(function () {
        var inp = document.querySelector('.search-modal__content input[type="search"], .search-modal__content .search__input');
        if (inp) { inp.value = NAMES[i].q; inp.focus(); inp.dispatchEvent(new Event('input', { bubbles: true })); }
      }, 90);
    });

    var i = 0;
    setInterval(function () {
      span.classList.add('is-out');
      setTimeout(function () {
        i = (i + 1) % NAMES.length;
        span.textContent = NAMES[i].label;
        a.href = '/search?q=' + encodeURIComponent(NAMES[i].q);
        span.classList.remove('is-out');
      }, 400);
    }, 2800);
  }

  function initLogo() {
    var img = document.querySelector('.header__heading-logo');
    if (!img) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    if (/([?&])width=\d+/.test(img.src)) {
      img.src = img.src.replace(/([?&])width=\d+/, '$1width=720');
    }
  }

  function initDroppedCarousel() {
    var grid = document.querySelector('.ma-dropped-grid');
    if (!grid || grid.parentNode.classList.contains('ma-dropped-viewport')) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.ma-dropped-card'));
    if (cards.length <= 2) return;
    var desktop = window.matchMedia('(min-width: 990px)');
    var start = 0;
    var maxStart = cards.length - 2;

    var viewport = document.createElement('div');
    viewport.className = 'ma-dropped-viewport';
    grid.parentNode.insertBefore(viewport, grid);
    viewport.appendChild(grid);

    var strip = document.createElement('div');
    strip.className = 'ma-dropped-strip';
    var track = document.createElement('div');
    track.className = 'ma-dropped-strip-track';
    strip.appendChild(track);

    cards.forEach(function (card, i) {
      var img = card.querySelector('.ma-dropped-img-primary');
      var name = card.querySelector('.ma-dropped-name');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ma-dropped-thumb';
      btn.setAttribute('aria-label', name ? name.textContent.trim() : 'Product ' + (i + 1));
      if (img) {
        var t = document.createElement('img');
        t.src = img.currentSrc || img.src;
        t.alt = '';
        btn.appendChild(t);
      }
      btn.addEventListener('click', function () {
        start = Math.min(i, maxStart);
        render();
        var active = track.children[start];
        if (active && active.scrollIntoView) {
          active.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
      track.appendChild(btn);
    });
    viewport.parentNode.insertBefore(strip, viewport.nextSibling);

    function step() {
      if (cards.length < 2) return 0;
      return cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
    }
    function render() {
      strip.style.display = '';
      if (start > maxStart) start = maxStart;
      if (start < 0) start = 0;
      grid.style.transform = 'translateX(' + (-start * step()) + 'px)';
      var second = start + 1;
      Array.prototype.forEach.call(track.children, function (t, i) {
        t.classList.toggle('is-active', i === start || i === second);
      });
    }
    render();
    window.addEventListener('resize', render, { passive: true });
    window.addEventListener('load', render);
  }

  function initPriceFormat() {
    document.querySelectorAll('.ma-dropped-price span').forEach(function (el) {
      el.textContent = el.textContent.replace(/\.00(?=\s|\D|$)/, '');
    });
  }

  function initAbarDismiss() {
    var abar = document.querySelector('.shopify-section-group-header-group.announcement-bar-section');
    if (!abar) return;
    var dismissed = false;
    try { dismissed = sessionStorage.getItem('ma-abar-dismissed') === '1'; } catch (e) {}
    if (dismissed) { document.body.classList.add('ma-abar-hidden'); return; }
    var bar = abar.querySelector('.announcement-bar') || abar;
    if (bar.querySelector('.ma-abar-close')) return;
    bar.style.position = 'relative';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ma-abar-close';
    btn.setAttribute('aria-label', 'Dismiss announcement');
    btn.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M2 2l12 12M14 2L2 14"/></svg>';
    btn.addEventListener('click', function () {
      document.body.classList.add('ma-abar-hidden');
      try { sessionStorage.setItem('ma-abar-dismissed', '1'); } catch (e) {}
      window.dispatchEvent(new Event('resize'));
    });
    bar.appendChild(btn);
  }

  function initSticky() {
    var abar = document.querySelector('.shopify-section-group-header-group.announcement-bar-section');
    var headerSection = document.querySelector('.shopify-section-group-header-group.section-header');
    if (!headerSection) return;
    var main = document.getElementById('MainContent') || document.querySelector('main');
    var hero = document.querySelector('.ma-hero');
    var hasHero = !!hero;
    var desktop = window.matchMedia('(min-width: 990px)');

    function abarHeight() {
      if (!abar || document.body.classList.contains('ma-abar-hidden') || desktop.matches) return 0;
      return abar.offsetHeight;
    }
    function stackHeight() {
      return abarHeight() + headerSection.offsetHeight;
    }
    function setOffset() {
      document.documentElement.style.setProperty('--ma-abar-h', abarHeight() + 'px');
      document.documentElement.style.setProperty('--ma-header-h', headerSection.offsetHeight + 'px');
      if (main && !hasHero) { main.style.paddingTop = stackHeight() + 'px'; }
    }
    function onScroll() {
      var flip;
      if (hasHero) {
        var threshold = hero.offsetHeight - stackHeight();
        flip = window.scrollY > Math.max(threshold, 0);
      } else {
        flip = window.scrollY > 8;
      }
      document.body.classList.toggle('ma-scrolled', flip);
    }
    setOffset(); onScroll();
    window.addEventListener('resize', function () { setOffset(); onScroll(); }, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Desktop: open the header mega-menu (Bags) on hover instead of on click. */
  function initMenuHover() {
    var mq = window.matchMedia('(min-width: 990px)');
    var list = document.querySelectorAll('.header__inline-menu details');
    Array.prototype.forEach.call(list, function (details) {
      if (!details || details.getAttribute('data-ma-hover')) return;
      details.setAttribute('data-ma-hover', '1');
      var summary = details.querySelector('summary');
      var closeTimer;
      function open() {
        if (!mq.matches) return;
        clearTimeout(closeTimer);
        if (!details.open) {
          details.open = true;
          if (summary) summary.setAttribute('aria-expanded', 'true');
        }
      }
      function close() {
        if (!mq.matches) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          details.open = false;
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, 140);
      }
      details.addEventListener('mouseenter', open);
      details.addEventListener('mouseleave', close);
      // Close when a link inside the panel is chosen.
      details.addEventListener('click', function (e) {
        if (mq.matches && e.target.closest('a')) {
          details.open = false;
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () { initLogo(); initRotator(); initSticky(); initDroppedCarousel(); initPriceFormat(); initMenuHover(); });

  document.addEventListener('shopify:section:load', function () {
    initDroppedCarousel();
    initPriceFormat();
  });
})();

/* Muse Aria -- Gentle Monster-style search overlay. */
(function () {
  var TRENDS_COLLECTIONS = ['new-arrivals', 'all-products'];
  var RV_KEY = 'ma-recently-viewed';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function getRV() { try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { return []; } }
  function setRV(a) { try { localStorage.setItem(RV_KEY, JSON.stringify(a)); } catch (e) {} }

  function recordProduct() {
    if (location.pathname.indexOf('/products/') === -1) return;
    var titleEl = document.querySelector('.product__title, h1.product__title, .product__title h1');
    if (!titleEl) return;
    var priceEl = document.querySelector('.price__regular .price-item, .price-item--regular, .price .price-item');
    var imgEl = document.querySelector('.product__media img, .product-media-container img, .product__media-item img');
    var url = location.pathname;
    var item = {
      url: url,
      title: ((titleEl.textContent || '').split('\n')[0] || '').replace(/\s+/g, ' ').trim(),
      price: priceEl ? (priceEl.textContent || '').replace(/\s+/g, ' ').trim() : '',
      image: imgEl ? (imgEl.currentSrc || imgEl.src || '') : ''
    };
    if (!item.title) return;
    var arr = getRV().filter(function (x) { return x.url !== url; });
    arr.unshift(item);
    setRV(arr.slice(0, 8));
  }

  function trendCard(p) {
    var img = (p.images && p.images[0] && p.images[0].src) || p.featured_image || '';
    var src = img ? (img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=360') : '';
    return '<a class="ma-search-card" href="/products/' + esc(p.handle) + '">' +
      '<span class="ma-search-thumb">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy">' : '') + '</span>' +
      '<span class="ma-search-name">' + esc(p.title) + '</span></a>';
  }
  function rvCard(p) {
    return '<a class="ma-search-card" href="' + esc(p.url) + '">' +
      '<span class="ma-search-thumb">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '') + '</span>' +
      '<span class="ma-search-name">' + esc(p.title) + '</span>' +
      (p.price ? '<span class="ma-search-price">' + esc(p.price) + '</span>' : '') + '</a>';
  }

  function fetchTrends(box, idx) {
    idx = idx || 0;
    if (!box || idx >= TRENDS_COLLECTIONS.length) return;
    fetch('/collections/' + TRENDS_COLLECTIONS[idx] + '/products.json?limit=6')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var items = (d && d.products) || [];
        if (!items.length) { return fetchTrends(box, idx + 1); }
        box.innerHTML = items.slice(0, 6).map(trendCard).join('');
      })
      .catch(function () { fetchTrends(box, idx + 1); });
  }

  function renderRV(panel) {
    var box = panel.querySelector('[data-ma-recent]');
    var section = panel.querySelector('.ma-search-recent');
    if (!box || !section) return;
    var arr = getRV();
    if (!arr.length) { section.setAttribute('hidden', ''); return; }
    section.removeAttribute('hidden');
    box.innerHTML = arr.slice(0, 8).map(rvCard).join('');
  }

  var BAHT = String.fromCharCode(0x0E3F);
  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    return BAHT + ' ' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function resultCard(p) {
    var img = (typeof p.image === 'string' && p.image) ||
              (p.featured_image && (typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.url)) || '';
    var src = img ? (img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=360') : '';
    var sold = (p.available === false) ? '<span class="ma-search-sold">Sold out</span>' : '';
    return '<a class="ma-search-card" href="' + esc(p.url) + '">' +
      '<span class="ma-search-thumb">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy">' : '') + sold + '</span>' +
      '<span class="ma-search-name">' + esc(p.title) + '</span>' +
      '<span class="ma-search-price">' + esc(money(p.price)) + '</span></a>';
  }

  var searchAbort;
  function doSearch(q, panel) {
    var results = panel.querySelector('.ma-search-results');
    var box = panel.querySelector('[data-ma-results]');
    var trends = panel.querySelector('.ma-search-trends');
    var recent = panel.querySelector('.ma-search-recent');
    if (!q) {
      if (results) results.setAttribute('hidden', '');
      if (trends) trends.removeAttribute('hidden');
      renderRV(panel);
      return;
    }
    if (trends) trends.setAttribute('hidden', '');
    if (recent) recent.setAttribute('hidden', '');
    if (results) results.removeAttribute('hidden');
    if (searchAbort) searchAbort.abort();
    searchAbort = new AbortController();
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=12&resources[options][unavailable_products]=last',
          { signal: searchAbort.signal })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var prods = (d.resources && d.resources.results && d.resources.results.products) || [];
        if (box) box.innerHTML = prods.length ? prods.map(resultCard).join('') : '<p class="ma-search-empty">No products found.</p>';
      })
      .catch(function () {});
  }

  function buildOverlay() {
    var content = document.querySelector('.search-modal__content');
    if (!content || content.querySelector('.ma-search-panel')) return;
    var input = content.querySelector('input[type="search"], .search__input');

    var panel = document.createElement('div');
    panel.className = 'ma-search-panel';
    panel.innerHTML =
      '<div class="ma-search-section ma-search-results" hidden>' +
        '<h3 class="ma-search-h">Products</h3>' +
        '<div class="ma-search-results-grid" data-ma-results></div>' +
      '</div>' +
      '<div class="ma-search-section ma-search-trends">' +
        '<h3 class="ma-search-h">Search Trends</h3>' +
        '<div class="ma-search-row" data-ma-trends></div>' +
      '</div>' +
      '<div class="ma-search-section ma-search-recent" hidden>' +
        '<div class="ma-search-head"><h3 class="ma-search-h">Recently Viewed</h3>' +
        '<button type="button" class="ma-search-remove">Remove</button></div>' +
        '<div class="ma-search-row" data-ma-recent></div>' +
      '</div>';
    content.appendChild(panel);

    var t;
    function onType() {
      var q = ((input && input.value) || '').trim();
      clearTimeout(t);
      t = setTimeout(function () { doSearch(q, panel); }, 180);
    }
    if (input) { input.addEventListener('input', onType); }

    // Keep search inside the overlay -- never navigate to the /search page.
    var form = content.querySelector('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        doSearch(((input && input.value) || '').trim(), panel);
      });
    }

    fetchTrends(panel.querySelector('[data-ma-trends]'), 0);
    renderRV(panel);
    doSearch(((input && input.value) || '').trim(), panel);

    var rm = panel.querySelector('.ma-search-remove');
    if (rm) { rm.addEventListener('click', function () { setRV([]); renderRV(panel); }); }
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    // The standalone search results page is retired -- send visitors home; search lives in the overlay.
    if (location.pathname === '/search') { location.replace('/'); return; }
    recordProduct();
    buildOverlay();
  });
  document.addEventListener('shopify:section:load', buildOverlay);
})();

/* Muse Aria -- Gentle Monster-style collection filter popup. */
(function () {
  var m = location.pathname.match(/\/collections\/([^\/?#]+)/);
  if (!m) return;
  var COLL = m[1];

  var CATS = [
    { label: 'Handbag', handle: 'top-handle' },
    { label: 'Crossbody', handle: 'crossbody' },
    { label: 'Shoulder Bag', handle: 'shoulder-bag' },
    { label: 'Tote Bag', handle: 'tote-bag' },
    { label: 'Evening Bag', handle: 'evening-bag' },
    { label: 'Summer Bag', handle: 'summer-bag' }
  ];

  var COLOR_ORDER = ['Black', 'White', 'Grey', 'Silver', 'Gold', 'Metallic', 'Brown', 'Beige', 'Green', 'Blue', 'Pink', 'Red', 'Purple', 'Yellow', 'Orange', 'Multi'];
  function baseColor(raw) {
    var t = (raw || '').toLowerCase();
    if (/multi|floral|print|zebra|leopard|snake/.test(t)) return 'Multi';
    if (/black|noir|onyx/.test(t)) return 'Black';
    if (/white|ivory|cream|off.?white/.test(t)) return 'White';
    if (/silver/.test(t)) return 'Silver';
    if (/\bgold/.test(t)) return 'Gold';
    if (/metallic|chrome/.test(t)) return 'Metallic';
    if (/grey|gray|charcoal|space|graphite/.test(t)) return 'Grey';
    if (/beige|sand|nude|khaki|taupe|\btan\b|camel/.test(t)) return 'Beige';
    if (/brown|chocolate|coffee|espresso|mocha|cognac/.test(t)) return 'Brown';
    if (/green|olive|sage|pistachio|mint|emerald/.test(t)) return 'Green';
    if (/blue|navy|teal|denim|cobalt|electric/.test(t)) return 'Blue';
    if (/pink|blush|rose|fuchsia|magenta/.test(t)) return 'Pink';
    if (/red|burgundy|maroon|wine|crimson|scarlet/.test(t)) return 'Red';
    if (/purple|lilac|lavender|violet|plum/.test(t)) return 'Purple';
    if (/yellow|mustard/.test(t)) return 'Yellow';
    if (/orange|rust|terracotta|coral/.test(t)) return 'Orange';
    return null;
  }
  function material(title) {
    var t = (title || '').toLowerCase();
    if (t.indexOf('suede') > -1) return 'Suede';
    if (t.indexOf('leather') > -1) return 'Leather';
    return null;
  }
  function colorsOf(p) {
    var idx = -1;
    (p.options || []).forEach(function (o) { if (/colou?r/i.test(o.name)) idx = o.position; });
    var set = {};
    if (idx > -1) {
      (p.variants || []).forEach(function (v) {
        var b = baseColor(v['option' + idx]);
        if (b) set[b] = 1;
      });
    }
    return Object.keys(set);
  }
  function priceOf(p) {
    var min = Infinity;
    (p.variants || []).forEach(function (v) { var pr = parseFloat(v.price); if (!isNaN(pr)) min = Math.min(min, pr); });
    return min === Infinity ? 0 : min;
  }
  function availOf(p) { return (p.variants || []).some(function (v) { return v.available; }); }

  function fetchAll(handle, cb) {
    var acc = [];
    (function page(n) {
      fetch('/collections/' + handle + '/products.json?limit=250&page=' + n)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          var items = (d && d.products) || [];
          acc = acc.concat(items);
          if (items.length === 250 && n < 5) { page(n + 1); } else { cb(acc); }
        })
        .catch(function () { cb(acc); });
    })(1);
  }

  var catSets = {};
  function loadCats(cb) {
    var pending = CATS.length;
    CATS.forEach(function (c) {
      fetchAll(c.handle, function (items) {
        catSets[c.label] = {};
        items.forEach(function (p) { catSets[c.label][p.handle] = 1; });
        if (--pending === 0) cb();
      });
    });
  }

  /* Each grid tile is a colour variant of a product (title ends "... - Colour").
     Keep every tile visible; the filter works per-variant-card. */
  var CARDS = [], META = {};
  function mapCards(grid) {
    Array.prototype.forEach.call(grid.children, function (li, i) {
      var a = li.querySelector('a[href*="/products/"]');
      if (!a) return;
      var mm = a.getAttribute('href').match(/\/products\/([^\/?#]+)/);
      if (!mm) return;
      var titleEl = li.querySelector('.card__heading, .card-information__text, .full-unstyled-link, h3');
      var title = (titleEl ? titleEl.textContent : '').replace(/\s+/g, ' ').trim();
      var parts = title.split(' - ');
      var color = parts.length > 1 ? baseColor(parts[parts.length - 1]) : null;
      CARDS.push({ li: li, handle: mm[1], origIndex: i, color: color, mat: material(title) });
    });
  }
  function buildMeta(items) {
    items.forEach(function (p) {
      META[p.handle] = { price: priceOf(p), created: new Date(p.published_at || p.created_at || 0).getTime(), colors: colorsOf(p) };
    });
  }
  /* Cards split by colour carry their own colour in the title; combined cards
     (e.g. a "Print/Colour" product shown as one tile) fall back to the product's
     full colour set so they still match the colour filter. */
  function enrichCardColors() {
    CARDS.forEach(function (c) {
      c.colors = c.color ? [c.color] : ((META[c.handle] && META[c.handle].colors) || []);
    });
  }
  function cardPrice(c) { return META[c.handle] ? META[c.handle].price : 0; }
  function cardCreated(c) { return META[c.handle] ? META[c.handle].created : 0; }
  function facetValues() {
    var colors = {}, mats = {}, cats = {};
    CARDS.forEach(function (c) { (c.colors || []).forEach(function (col) { colors[col] = 1; }); if (c.mat) mats[c.mat] = 1; });
    CATS.forEach(function (cat) {
      var s = catSets[cat.label];
      if (s && CARDS.some(function (c) { return s[c.handle]; })) cats[cat.label] = 1;
    });
    return {
      colors: COLOR_ORDER.filter(function (c) { return colors[c]; }),
      materials: ['Leather', 'Suede'].filter(function (mm) { return mats[mm]; }),
      categories: CATS.filter(function (c) { return cats[c.label]; }).map(function (c) { return c.label; })
    };
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function buildUI(grid) {
    if (!CARDS.length || document.querySelector('.ma-filter-bar')) return;

    var bar = document.createElement('div');
    bar.className = 'ma-filter-bar';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ma-filter-btn';
    btn.innerHTML = 'Filter <svg viewBox="0 0 20 20" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M3 5.5h14M6 10h8M9 14.5h2"/></svg>';
    bar.appendChild(btn);
    grid.parentNode.insertBefore(bar, grid);

    var ov = document.createElement('div');
    ov.className = 'ma-filter-overlay';
    ov.setAttribute('hidden', '');

    var fv = facetValues();
    function group(title, name, values, type, extra) {
      if (!values.length) return '';
      var opts = values.map(function (v) {
        return '<label class="ma-filter-opt"><input type="' + type + '" name="ma-' + name + '" value="' + esc(v) + '"><span>' + esc(v) + '</span></label>';
      }).join('');
      return '<div class="ma-filter-col' + (extra || '') + '"><h4>' + esc(title) + '</h4><div class="ma-filter-opts">' + opts + '</div></div>';
    }
    var colsHtml =
      group('Color', 'color', fv.colors, 'checkbox', ' ma-filter-col--color') +
      group('Material', 'material', fv.materials, 'checkbox', '') +
      group('Category', 'category', fv.categories, 'checkbox', '') +
      '<div class="ma-filter-col"><h4>Sort by</h4><div class="ma-filter-opts">' +
        '<label class="ma-filter-opt"><input type="radio" name="ma-sort" value="newest"><span>Newest</span></label>' +
        '<label class="ma-filter-opt"><input type="radio" name="ma-sort" value="low"><span>Lowest Price</span></label>' +
        '<label class="ma-filter-opt"><input type="radio" name="ma-sort" value="high"><span>Highest Price</span></label>' +
      '</div></div>';

    ov.innerHTML =
      '<div class="ma-filter-inner">' +
        '<div class="ma-filter-head"><span class="ma-filter-title">Filter<sup class="ma-filter-count"></sup></span>' +
        '<button type="button" class="ma-filter-close" aria-label="Close filter">&times;</button></div>' +
        '<div class="ma-filter-cols">' + colsHtml + '</div>' +
        '<div class="ma-filter-actions"><button type="button" class="ma-filter-clear">Clear</button>' +
        '<button type="button" class="ma-filter-apply">Apply</button></div>' +
      '</div>';
    document.body.appendChild(ov);

    function selected(name) { return Array.prototype.map.call(ov.querySelectorAll('input[name="ma-' + name + '"]:checked'), function (i) { return i.value; }); }
    function sortVal() { var r = ov.querySelector('input[name="ma-sort"]:checked'); return r ? r.value : ''; }
    function compute() {
      var sc = selected('color'), sm = selected('material'), scat = selected('category');
      return CARDS.filter(function (c) {
        if (sc.length && !(c.colors || []).some(function (col) { return sc.indexOf(col) > -1; })) return false;
        if (sm.length && (!c.mat || sm.indexOf(c.mat) === -1)) return false;
        if (scat.length && !scat.some(function (cat) { var s = catSets[cat]; return s && s[c.handle]; })) return false;
        return true;
      });
    }
    function updateCount() { ov.querySelector('.ma-filter-count').textContent = compute().length; }
    ov.addEventListener('change', updateCount);

    function openOv() { ov.removeAttribute('hidden'); updateCount(); }
    function closeOv() { ov.setAttribute('hidden', ''); }
    btn.addEventListener('click', function () { ov.hasAttribute('hidden') ? openOv() : closeOv(); });
    ov.querySelector('.ma-filter-close').addEventListener('click', closeOv);

    ov.querySelector('.ma-filter-apply').addEventListener('click', function () {
      var list = compute(), s = sortVal();
      if (s === 'newest') list.sort(function (a, b) { return cardCreated(b) - cardCreated(a) || a.origIndex - b.origIndex; });
      else if (s === 'low') list.sort(function (a, b) { return cardPrice(a) - cardPrice(b) || a.origIndex - b.origIndex; });
      else if (s === 'high') list.sort(function (a, b) { return cardPrice(b) - cardPrice(a) || a.origIndex - b.origIndex; });
      else list.sort(function (a, b) { return a.origIndex - b.origIndex; });
      CARDS.forEach(function (c) { c.li.style.display = 'none'; });
      list.forEach(function (c) { c.li.style.display = ''; grid.appendChild(c.li); });
      var active = selected('color').length + selected('material').length + selected('category').length > 0 || !!s;
      btn.classList.toggle('is-active', active);
      closeOv();
    });
    ov.querySelector('.ma-filter-clear').addEventListener('click', function () {
      Array.prototype.forEach.call(ov.querySelectorAll('input'), function (i) { i.checked = false; });
      CARDS.slice().sort(function (a, b) { return a.origIndex - b.origIndex; }).forEach(function (c) { c.li.style.display = ''; grid.appendChild(c.li); });
      btn.classList.remove('is-active');
      updateCount();
    });
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    mapCards(grid);
    if (!CARDS.length) return;
    loadCats(function () {
      fetchAll(COLL, function (items) {
        buildMeta(items);
        enrichCardColors();
        buildUI(grid);
      });
    });
  });
})();

/* Muse Aria -- GM-style product page (image swatches, open description, mobile buy bar). */
(function () {
  if (location.pathname.indexOf('/products/') === -1) return;

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  function colorFieldset() {
    return Array.prototype.filter.call(document.querySelectorAll('.product-form__input'), function (f) {
      var l = f.querySelector('legend');
      return l && /colou?r/i.test(l.textContent);
    })[0];
  }

  /* Turn the colour pills into image swatches + a colour-name label. */
  function initSwatches() {
    var fs = colorFieldset();
    if (!fs || fs.classList.contains('ma-swatches')) return;
    var handle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var map = {};
        (p.variants || []).forEach(function (v) {
          var src = (v.featured_image && v.featured_image.src) ? v.featured_image.src : (p.featured_image || '');
          if (src && !map[v.option1]) map[v.option1] = src;
        });
        fs.classList.add('ma-swatches');
        Array.prototype.forEach.call(fs.querySelectorAll('label'), function (label) {
          var forId = label.getAttribute('for');
          var input = forId ? document.getElementById(forId) : null;
          var val = input ? input.value : label.textContent.trim();
          label.setAttribute('data-ma-color', val);
          var src = map[val];
          if (src) {
            var url = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=140';
            label.style.backgroundImage = 'url("' + url + '")';
          }
        });
        var legend = fs.querySelector('legend');
        var name = document.createElement('span');
        name.className = 'ma-color-name';
        if (legend) legend.appendChild(name);
        function upd() { var c = fs.querySelector('input:checked'); if (name) name.textContent = c ? c.value : ''; }
        upd();
        fs.addEventListener('change', upd);
      })
      .catch(function () {});
  }

  /* Move the description into a collapsible that is open on load (others stay shut). */
  function initDescriptionAccordion() {
    var desc = document.querySelector('.product__description');
    var template = document.querySelector('.product__accordion.accordion');
    if (!desc || !template || desc.getAttribute('data-ma-acc')) return;
    desc.setAttribute('data-ma-acc', '1');
    var clone = template.cloneNode(true);
    clone.classList.add('ma-desc-accordion');
    var titleEl = clone.querySelector('.summary__title');
    if (titleEl) titleEl.textContent = 'DETAILS';
    var content = clone.querySelector('.accordion__content');
    if (content) content.innerHTML = desc.innerHTML;
    var details = clone.querySelector('details');
    if (details) details.open = true;
    desc.parentNode.replaceChild(clone, desc);
  }

  /* Mobile sticky add-to-cart bar (GM style). */
  function initMobileBar() {
    if (document.querySelector('.ma-buybar')) return;
    var atc = document.querySelector('.product-form__submit');
    if (!atc) return;
    var titleEl = document.querySelector('.product__title');
    var bar = document.createElement('div');
    bar.className = 'ma-buybar';
    bar.innerHTML =
      '<div class="ma-buybar-info"><span class="ma-buybar-title"></span><span class="ma-buybar-price"></span></div>' +
      '<button type="button" class="ma-buybar-btn">Add to cart</button>';
    document.body.appendChild(bar);
    bar.querySelector('.ma-buybar-title').textContent = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';
    function priceNow() {
      var pe = document.querySelector('.price:not(.price--sold-out) .price-item--regular, .price__regular .price-item, .price .price-item');
      return pe ? pe.textContent.replace(/\s+/g, ' ').trim() : '';
    }
    function syncPrice() { bar.querySelector('.ma-buybar-price').textContent = priceNow(); }
    syncPrice();
    bar.querySelector('.ma-buybar-btn').addEventListener('click', function () { atc.click(); });
    document.addEventListener('change', function (e) {
      if (e.target && /colou?r/i.test(e.target.name || '')) { setTimeout(syncPrice, 350); }
    });
  }

  ready(function () { initSwatches(); initDescriptionAccordion(); initMobileBar(); });
})();

/* Muse Aria -- strip the published date from Journal listing meta (keeps read time). */
(function () {
  if (location.pathname.indexOf('/blogs/') === -1) return;
  var dateRe = /\b\d{1,2}\s+[A-Za-z]{3,}\s+\d{4}\b/;
  function strip() {
    Array.prototype.forEach.call(document.querySelectorAll('.ed-meta'), function (m) {
      if (m.children.length === 0 && dateRe.test(m.textContent)) {
        m.textContent = m.textContent.replace(dateRe, '')
          .replace(/^[\s·|,–-]+/, '').replace(/[\s·|,–-]+$/, '')
          .replace(/\s{2,}/g, ' ').trim();
      }
    });
  }
  if (document.readyState !== 'loading') strip();
  else document.addEventListener('DOMContentLoaded', strip);
})();
